import SinglePrediction from 'src/features/Public/AIHSCodeLabeling/SinglePrediction';
import PublicPageContainer from 'src/features/Public/PublicPageContainer';

const SinglePredictionPublicPage = () => {
  return (
    <PublicPageContainer>
      <SinglePrediction />
    </PublicPageContainer>
  );
};

export default SinglePredictionPublicPage;
